<template>
  <div class="project-detail">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ProjectDetail',
  
  computed: {
    projectId() {
      return this.$route.params.projectId
    }
  }
}
</script>

<style lang="scss" scoped>
.project-detail {
  height: 100%;
}
</style>
